import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './pos.css';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // POS needs reasonably fresh data but can tolerate brief stale periods
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      // Network error retry with backoff
      retry: 2,
    },
  },
});

// Register service worker for offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW registration failure is non-fatal — app works online without it
    });
  });
}

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
